import { useState } from 'react';

import { MarketCountryCode } from '../../../../../../lib/models/fundamental/types';
import MarketHoursState from '../../../../../../lib/store-util/MarketHoursState';
import { useMarketState } from '../../../../../../lib/util/hooks/useMarketState';

import ClickableDiv from '../../../../../../shared_components/ClickableDiv/ClickableDiv';
import useIsMobile from '../../../../../../shared_components/hooks/useIsMobile';
import { getMarketStateWithTimes } from '../../../../../MarketStatesModal/market-states-modal-helpers';
import MarketStatesModal from '../../../../../MarketStatesModal/MarketStatesModal';

import styles from './MarketStateButton.module.scss';

const MarketStateButton = () => {
  const { isMobile } = useIsMobile();
  const [showModal, setShowModal] = useState<boolean>(false);

  const { marketHours, nonWorkingDays } = MarketHoursState.get(MarketCountryCode.UnitedStates);
  const { marketState } = useMarketState(MarketCountryCode.UnitedStates);

  const [{
    icon,
    iconAlt,
    title,
    verticalLineColor: color,
    iconBackgroundColor: backgroundColor,
  }] = getMarketStateWithTimes(marketHours, marketState, nonWorkingDays);

  return (
    <>
      <ClickableDiv className={styles.wrapper} style={{ color, backgroundColor }} onClick={() => setShowModal(true)}>
        <img src={icon} alt={iconAlt} />
        {!isMobile && <div>{title}</div>}
      </ClickableDiv>
      <MarketStatesModal isOpen={showModal} setIsOpen={setShowModal} />
    </>
  );
};

export default MarketStateButton;
